import { useQuery } from "react-query";
import { localConfig } from "../../../Configs/localConfig";
import { api } from "../../api";
import { errorAlert } from "../../../utils/alert";

export type typeSafra = {
    cod: number,
    cod_conta: number,
    cod_cliente: number,
    cod_cultura: number,
    nome: string,
    data_inicio: string,
    data_final: string,
    status: number,
    cod_cultura_secundaria: number,
    cod_replica: number,
    cultura: {
        cod: number,
        nome: string,
        nome_cientifico: string,
        unidade_colheita: number
    }[]
}

export interface Safra {
    itens: typeSafra[]
}

export const useGetSafraConsultoria = () => {

    let { conta } = localConfig();

    const queryKey: any = ['safra', conta];

    const { data, isFetching, refetch } = useQuery<Safra, Error>(queryKey, async () => {
        return api.get(`/safra?codConta=${conta}&pagination=-1`)
            .then((response): any => {
                return response.data
            })
            .catch((error) => {
                errorAlert(error?.response?.data?.error ?? 'Falha ao obter safras!');
            })
    },
        {
            enabled: true,
            refetchOnWindowFocus: false,
            staleTime: 300000 // 5 min
            // staleTime: 200000
        }
    );

    return {
        data_safras: data?.itens,
        carregando_safras: isFetching,
        refetch_safras: refetch
    };
};